import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { Toaster } from "./components/ui/toaster";
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import MenuSection from "./components/MenuSection";
import GallerySection from "./components/GallerySection";
import WineSection from "./components/WineSection";
import FavoritesSection from "./components/FavoritesSection";
import ContactSection from "./components/ContactSection";
import AdminLogin from "./components/AdminLogin";
import WorkshopsSection from "./components/WorkshopsSection";

const Home = () => {
  return (
    <div className="min-h-screen bg-warm-white">
      <Navigation />
      <HeroSection />
      <MenuSection />
      <WineSection />
      <ContactSection />
      <GallerySection />

      {/* Footer */}
      <footer className="bg-primary text-white py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h3 className="text-2xl font-serif font-bold mb-4">Au 4A</h3>
            <p className="text-gray-300 mb-4">
              Une expérience culinaire authentique au cœur d'Antheit
            </p>
            <div className="flex justify-center space-x-6 text-sm text-gray-300">
              <span>© 2025 Au 4A Restaurant</span>
              <span>•</span>
              <span>Antheit, Belgique</span>
              <span>•</span>
              <span>Tous droits réservés</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin-login" element={<AdminLogin />} />
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;
